<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <CaseACocherLive
        code="decla1"
        v-model="sasInscriptionRegistreEtudiant.declarationInscription"
        :live="liveSasInscriptionRegistreEtudiant(5613)"
      />
      <CaseACocherLive
        code="decla2"
        v-model="sasInscriptionRegistreEtudiant.declarationInformationsUniversite"
        :live="liveSasInscriptionRegistreEtudiant(5614)"
      />
    </v-form>
  </div>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
export default {
  mixins: [StepFormWithValidation],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasInscriptionRegistreEtudiant() {
      return this.sas.sasInscriptionRegistreEtudiant
    }
  },
  methods: {
    liveSasInscriptionRegistreEtudiant(cle) {
      return { endpoint: "sas-inscription-etudiant", cle: cle, fileId: this.sasInscriptionRegistreEtudiant.id }
    }
  }
}
</script>

<style>
</style>